import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState } from "react";
import axios from "axios";

const New = ({ inputs, title }) => {
  const [image, setImage] = useState(null); // For file selection
  const [imageUrl, setImageUrl] = useState(""); // For storing uploaded file location
  const [info, setInfo] = useState({});
  const [error, setError] = useState("");

  // Handle form field changes
  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  // Handle image upload
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(selectedFile.type)) {
      setError("Only image files (JPEG, PNG, JPG) are allowed!");
      return;
    }

    setError(""); // Clear any previous error
    setImage(selectedFile);

    // Upload the image to the backend
    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const res = await axios.post(
        "https://api.mecdistanceeducation.com/api/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("res.data.imageUrl", res.data.imageUrl);

      setImageUrl(res.data.imageUrl); // Save the uploaded image URL
    } catch (err) {
      console.log(err);
      setError("Failed to upload image. Please try again.");
    }
  };

  // Handle form submission
  const handleClick = async (e) => {
    e.preventDefault();

    // if (!imageUrl) {
    //   setError("Please upload an image.");
    //   return;
    // }

    if (
      !info.name ||
      !info.text ||
      !info.duration ||
      !info.fees ||
      !info.eligibility ||
      !info.universities ||
      !info.about ||
      !info.fullform 
    ) {
      setError("Please fill all required fields.");
      return;
    }

    try {
      const token = localStorage.getItem("access_token"); // Retrieve token from localStorage
      // const newCourse = { ...info, imageUrl }; // Include image URL in the payload
      // console.log("newCourse",newCourse);
      // const formData = new FormData();
      // formData.append("name", info.name);
      // formData.append("text", info.text);
      // formData.append("imageUrl", imageUrl);
      // console.log("formData",formData);
      const newCourse = {
        name: info.name,
        text: info.text,
        duration: info.duration,
        fees: info.fees,
        eligibility: info.eligibility,
        universities: info.universities,
        about: info.about,
        fullform: info.fullform,
        // imageUrl: imageUrl,
      };
      console.log("newCourse", newCourse);

      // await axios.post("https://api.mecdistanceeducation.com/api/courses", newCourse);
      const response = await axios.post(
        "https://api.mecdistanceeducation.com/api/courses",
        newCourse,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token in the request header
            // "Content-Type": "multipart/form-data",
          },
        }
      );
      const baseUrl = window.location.origin;
      const urlToNavigate = `${baseUrl}/courses`;
      window.location.href = urlToNavigate;
    } catch (err) {
      console.log(err);
      setError("Failed to save course. Please try again.");
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {/* <div className="formInput">
                <label htmlFor="file">
                  Upload Image:{" "}
                  <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div> */}

              {/* {image && (
                <p>
                  Selected File: <strong>{image.name}</strong>
                </p>
              )} */}

              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    onChange={handleChange}
                    type={input.type}
                    placeholder={input.placeholder}
                    id={input.id}
                  />
                </div>
              ))}

              {error && <p className="error">{error}</p>}

              <button onClick={handleClick}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
